'use client';

import { useTranslation } from '@root/src/i18n/client';
import CollectionCard from './collectionCard';
import MobileTwoColumnCarousel from '../common/MobileTwoColumnCarousel';

interface OtherCollectionsProps {
  collections?: Array<{
    name: string;
    slug: string;
    description?: string;
    image?: string[] | string;
  }>;
}

export default function OtherCollections({
  collections = [],
}: OtherCollectionsProps) {
  const { t } = useTranslation('common');

  if (!collections.length) {
    return null;
  }

  return (
    <section className="relative min-h-[430px] overflow-hidden px-4 py-8 sm:min-h-[492px] sm:px-6 sm:py-10 lg:min-h-[500px] lg:px-8 lg:py-12">
      <div className="mx-auto mb-6 max-w-3xl text-center sm:mb-8">
        <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-[#9a825d]">
          {t('lytra.otherCollectionsTitle')}
        </h3>
      </div>

      <div className="mx-auto hidden max-w-[1480px] sm:block">
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-8">
          {collections.map(collection => (
            <CollectionCard
              key={collection.slug}
              slug={collection.slug}
              name={collection.name}
              description={collection.description}
              image={collection.image}
            />
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-[1480px]">
        <MobileTwoColumnCarousel
          items={collections}
          renderItem={collection => (
            <CollectionCard
              key={collection.slug}
              slug={collection.slug}
              name={collection.name}
              description={collection.description}
              image={collection.image}
            />
          )}
        />
      </div>
    </section>
  );
}
